export function getQueryObject(url) {
  url = url || window.location.search
  const theRequest = {}
  if (url.indexOf('?') !== -1) {
    const str = url.substr(1)
    const strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1])
    }
  }
  return theRequest
}

export function getQueryString(url) {
  url = url || window.location.search
  let theRequest = ''
  if (url.indexOf('?') !== -1) {
    theRequest = url.substr(1)
  }
  return theRequest
}

export const loading = (() => {
  let index
  const open = (content) => {
    index = window.layui['layer-mobile'].open({
      type: 2,
      content
    })
  }
  const close = () => {
    window.layui['layer-mobile'].close(index)
  }
  return {
    open,
    close
  }
})()

export const JSONParse = (target, def = {}) => {
  try {
    return JSON.parse(target)
  } catch (e) {
    return def
  }
}

export const JSONStringify = (target) => {
  return JSON.stringify(typeof target === 'object' ? target : {})
}

export const tip = (text) => {
  window.layui['layer'].open({
    title: 'Tip',
    content: text,
    btn: 'Confirm'
  })
}

export const getCache = () => {
  return window.layui['layim-mobile'].cache()
}
